import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _NewItemAnalysis;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Heading } from '@instructure/ui-heading';
import { PresentationContent } from '@instructure/ui-a11y-content';
import PropTypes from 'prop-types';
import { Component } from 'react';
import generateStyle from './styles';
import t from '@instructure/quiz-i18n/es/format-message';
import ExpandButton from '../../../../../common/components/shared/ExpandButton';
import { Text } from '@instructure/ui-text';
import { jsx, css } from '@instructure/emotion';
import generateComponentTheme from './theme';
import { difficultyIndex, discriminationIndex, pearsonCorrelation } from './popoverContent';
import Card from '../../../../../common/components/shared/Card';
import AnalysisMetric from '../AnalysisMetric';
import AnalysisPopoverMetric from '../AnalysisPopoverMetric';
import { interactionTypesNameDictionary } from '../../../../../common/util/interactionTypeMetadata';
import AnswerFrequencySummary from '../AnswerFrequencySummary/index';
import { afsFlags, itemAnalysisPropType } from '../../common/propTypes';
import { RichContentRenderer } from '@instructure/quiz-rce';
import { ensureRCEContentIsLoaded } from '../../../../../common/util/rceChecker';
import { Flex, RICH_FILL_BLANK_SLUG, withStyleOverrides } from '@instructure/quiz-common';
var parser = new DOMParser();
var parsererrorElement = 'parsererror';
var parseType = 'text/html';
export var NewItemAnalysis = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_NewItemAnalysis = /*#__PURE__*/function (_Component) {
  function NewItemAnalysis() {
    var _this;
    _classCallCheck(this, NewItemAnalysis);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, NewItemAnalysis, [].concat(args));
    _defineProperty(_this, "state", {
      bodyExpanded: false,
      metricsExpanded: false,
      itemCardBodyHeight: 0
    });
    _defineProperty(_this, "mapInteractionTypeToTranslation", function (interactionType) {
      return interactionTypesNameDictionary({
        slug: interactionType,
        name: t('Question')
      });
    });
    _defineProperty(_this, "handleMetricToggle", function () {
      _this.setState({
        metricsExpanded: !_this.state.metricsExpanded
      });
    });
    _defineProperty(_this, "handleBodyToggle", function () {
      _this.setState({
        bodyExpanded: !_this.state.bodyExpanded
      });
    });
    _defineProperty(_this, "calculateValueWithPointsPossible", function (metricKey, metricValue) {
      var pointsPossible = _this.props.itemAnalysis.scores.points_possible;
      return t.rich('{score, number}<s>/{possible, number} PTS</s>', {
        s: function s(_ref) {
          var children = _ref.children;
          return jsx("span", {
            key: metricKey,
            css: _this.props.styles.metricNumberContext
          }, children);
        },
        score: metricValue,
        possible: pointsPossible
      });
    });
    _defineProperty(_this, "renderTitle", function (title) {
      return jsx(Heading, {
        margin: "0 x-large small 0",
        level: "h3",
        color: "primary"
      }, title);
    });
    _defineProperty(_this, "renderInteractionType", function (interactionType) {
      return jsx(Text, {
        size: "medium",
        weight: "bold",
        transform: "capitalize"
      }, _this.mapInteractionTypeToTranslation(interactionType));
    });
    _defineProperty(_this, "isBlank", function (element) {
      if (element.textContent) return false;
      if (!element.hasAttribute('id')) return false;
      var regex = new RegExp('^blank_.+$');
      return regex.test(element.getAttribute('id'));
    });
    _defineProperty(_this, "enhanceItemBody", function (itemBody) {
      var tempDoc = parser.parseFromString(itemBody, parseType);
      var errorNode = tempDoc.querySelector(parsererrorElement);
      if (errorNode) {
        console.error('Parsing failed: ', errorNode);
        return itemBody;
      }
      Array.from(tempDoc.querySelectorAll('span')).filter(function (span) {
        return _this.isBlank(span);
      }).forEach(function (span, index) {
        var newSpan = span.cloneNode();
        newSpan.setAttribute('style', css(_this.props.styles.blankSpace).styles);
        newSpan.innerHTML = "".concat(index + 1);
        span.replaceWith(newSpan);
      });
      return tempDoc.querySelector('body').innerHTML;
    });
    _defineProperty(_this, "renderRichContent", function (itemBody, itemId) {
      return jsx(Flex, {
        direction: "row",
        alignItems: "start"
      }, jsx(Flex.Item, {
        shouldShrink: true,
        shouldGrow: true
      }, jsx("div", {
        id: _this.itemCardBodyId(itemId),
        css: _this.props.styles.itemBody
      }, jsx(RichContentRenderer, {
        content: itemBody
      }))), jsx(Flex.Item, {
        margin: "none none none x-small"
      }, jsx("div", {
        css: _this.props.styles.itemBodyToggleButtonWrapper
      }, _this.isBodyHigherThanContainer() && jsx(PresentationContent, null, jsx(ExpandButton, {
        onClick: _this.handleBodyToggle,
        title: _this.state.bodyExpanded ? t('collapse question stem') : t('expand question stem'),
        isExpanded: _this.state.bodyExpanded
      })))));
    });
    _defineProperty(_this, "renderMetrics", function (scores) {
      return jsx(Flex, {
        direction: "column"
      }, jsx(Flex.Item, {
        overflowY: "visible"
      }, jsx(Flex, {
        wrap: "wrap",
        direction: "row",
        alignItems: "start",
        gap: "medium"
      }, jsx(Flex.Item, {
        margin: "none medium none none"
      }, jsx(AnalysisPopoverMetric, {
        metricKey: "difficulty_index",
        label: t('Item Difficulty'),
        value: scores.difficulty_index,
        popoverDescription: difficultyIndex
      })), jsx(Flex.Item, {
        margin: "none medium none none"
      }, jsx(AnalysisMetric, {
        metricKey: "mean",
        label: t('Mean Earned Points'),
        value: _this.calculateValueWithPointsPossible('mean', scores.mean)
      })), jsx(Flex.Item, {
        margin: "none medium none none"
      }, jsx(AnalysisMetric, {
        metricKey: "median",
        label: t('Median Earned Points'),
        value: _this.calculateValueWithPointsPossible('median', scores.median)
      })), jsx(Flex.Item, {
        margin: "none large none none"
      }, jsx(AnalysisPopoverMetric, {
        metricKey: "discrimination_index",
        label: t('Discrimination Index'),
        value: scores.discrimination_index,
        popoverDescription: discriminationIndex
      })))), jsx(Flex.Item, null, jsx("div", {
        css: _this.props.styles.itemCardToggleButtonWrapper
      }, jsx(ExpandButton, {
        onClick: _this.handleMetricToggle,
        title: _this.state.metricsExpanded ? t('collapse item card') : t('expand item card'),
        isExpanded: _this.state.metricsExpanded
      }))), jsx(Flex.Item, {
        overflowY: "visible",
        margin: "medium none none none"
      }, jsx("div", {
        css: _this.props.styles.hiddenWhenNotExpanded
      }, jsx("div", {
        css: _this.props.styles.metricsContainer
      }, jsx(Flex.Item, {
        margin: "none medium none none"
      }, jsx(AnalysisPopoverMetric, {
        metricKey: "pearson_correlation",
        label: t('Corrected Item-Total Correlation Coefficient'),
        value: scores.pearson_correlation,
        popoverDescription: pearsonCorrelation
      }))))));
    });
    _defineProperty(_this, "renderAnswerSummaryTable", function (itemId, answer_summary, interactionType, afsFlags) {
      return jsx(Flex.Item, null, jsx("div", {
        css: _this.props.styles.hiddenWhenNotExpanded
      }, jsx(AnswerFrequencySummary, {
        itemId: itemId,
        answerSummary: answer_summary,
        interactionType: interactionType,
        afsFlags: afsFlags
      })));
    });
    _defineProperty(_this, "shouldEnhanceItemBody", function () {
      var _this$props = _this.props,
        itemAnalysis = _this$props.itemAnalysis,
        afsFlags = _this$props.afsFlags;
      var metadata = itemAnalysis.metadata;
      return afsFlags.fillInTheBlankEnabled && metadata.interaction_type === RICH_FILL_BLANK_SLUG && metadata.item_body;
    });
    return _this;
  }
  _inherits(NewItemAnalysis, _Component);
  return _createClass(NewItemAnalysis, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles({
        metricsExpanded: this.state.metricsExpanded,
        itemCardBodyHeight: this.state.itemCardBodyHeight,
        bodyExpanded: this.state.bodyExpanded
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.props.makeStyles({
        metricsExpanded: this.state.metricsExpanded,
        itemCardBodyHeight: this.state.itemCardBodyHeight,
        bodyExpanded: this.state.bodyExpanded
      });
      ensureRCEContentIsLoaded().then(function () {
        return _this2.calculateItemCardBodyHeight(_this2.props.itemAnalysis.metadata.item_id);
      });
    }
  }, {
    key: "calculateItemCardBodyHeight",
    value: function calculateItemCardBodyHeight(id) {
      var element = document.getElementById(this.itemCardBodyId(id));
      if (element) {
        var height = element.clientHeight;
        this.setState({
          itemCardBodyHeight: height
        });
      }
    }
  }, {
    key: "itemCardBodyId",
    value: function itemCardBodyId(itemId) {
      return "itemCardBody-".concat(itemId);
    }
  }, {
    key: "isBodyHigherThanContainer",
    value: function isBodyHigherThanContainer() {
      var containerHeight = 48;
      return this.state.itemCardBodyHeight > containerHeight;
    }
  }, {
    key: "render",
    value: function render() {
      var _metadata$item_title;
      var _this$props2 = this.props,
        itemAnalysis = _this$props2.itemAnalysis,
        afsFlags = _this$props2.afsFlags;
      var answer_summary = itemAnalysis.answer_summary,
        metadata = itemAnalysis.metadata,
        scores = itemAnalysis.scores;
      var itemId = metadata.item_id;
      var interactionType = metadata.interaction_type;
      var title = (_metadata$item_title = metadata.item_title) !== null && _metadata$item_title !== void 0 ? _metadata$item_title : t('Untitled item');
      var itemBodyEnhanced = this.shouldEnhanceItemBody() ? this.enhanceItemBody(metadata.item_body) : metadata.item_body;
      return jsx(Card, {
        css: this.props.styles.cardWrapper
      }, jsx(Flex, {
        direction: "column"
      }, jsx(Flex.Item, {
        overflowY: "visible"
      }, jsx("div", {
        css: this.props.styles.itemCardInnerContainer
      }, jsx(Flex.Item, {
        shouldGrow: true,
        shouldShrink: true,
        size: "45%"
      }, jsx(Flex, {
        direction: "column",
        justifyItems: "start"
      }, jsx(Flex.Item, null, this.renderTitle(title)), jsx(Flex.Item, null, this.renderInteractionType(metadata.interaction_type)), jsx(Flex.Item, {
        shouldShrink: true,
        padding: "small xx-small none none",
        overflowY: "hidden",
        size: !this.state.bodyExpanded ? '60px' : undefined
      }, this.renderRichContent(itemBodyEnhanced, itemId)))), jsx(Flex.Item, null, this.renderMetrics(scores)))), this.renderAnswerSummaryTable(itemId, answer_summary, interactionType, afsFlags)));
    }
  }]);
}(Component), _defineProperty(_NewItemAnalysis, "displayName", 'NewItemAnalysis'), _defineProperty(_NewItemAnalysis, "componentId", "Quizzes".concat(_NewItemAnalysis.displayName)), _defineProperty(_NewItemAnalysis, "propTypes", {
  itemAnalysis: itemAnalysisPropType,
  afsFlags: afsFlags,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _NewItemAnalysis)) || _class);